import { ComponentProps } from "react";
import { BlockTitle } from "@blocks/Blocks";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

type LatestStoriesProps = {
  /** The list of card props to be displayed. */
  cardProps: ComponentProps<typeof Card>[];
  /** Optional additional styling for the component. */
  className?: string;
};

/**
 * LatestStories component to display the latest news stories for Singapore Budget page.
 * Figma: https://www.figma.com/design/FZiuxiCLQaNXAJmLRtAAY9/BUDGET-2025--WEB---APP---NL-?node-id=8518-386935&t=PUAyvdavKczeZd7x-4
 */
const LatestStories = ({ cardProps, className }: LatestStoriesProps) => {
  const variation: CardVariations = {
    title: {
      size: "text-lg",
      color: "text-black",
      extraClass: cn("font-bold font-lct"),
    },
    kicker: {
      color: "text-black",
      extraClass: cn("font-poppins text-4xs font-light leading-6"),
    },
  };

  return (
    <div
      data-testid="singapore-budget-latest-stories-component"
      className={className}
    >
      <BlockTitle text="LATEST NEWS" />

      <div className="divide-y border-gray-175">
        {cardProps.map((card) => {
          return (
            <Card
              {...card}
              key={`budget-latest-stories-${card.id}`}
              variations={variation}
              className="py-4"
            />
          );
        })}
      </div>
    </div>
  );
};

export default LatestStories;
